import request from '@/utils/request'


// 查询用户优惠券信息列表
export function listCoupon(query) {
  return request({
    url: '/user/user-coupon/list',
    method: 'get',
    params: query
  })
}

// 查询用户优惠券信息分页
export function pageCoupon(query) {
  return request({
    url: '/user/user-coupon/page',
    method: 'get',
    params: query
  })
}

// 查询用户优惠券信息详细
export function getCoupon(data) {
  return request({
    url: '/user/user-coupon/detail',
    method: 'get',
    params: data
  })
}

// 新增用户优惠券信息
export function addCoupon(data) {
  return request({
    url: '/user/user-coupon/add',
    method: 'post',
    data: data
  })
}

// 修改用户优惠券信息
export function updateCoupon(data) {
  return request({
    url: '/user/user-coupon/edit',
    method: 'post',
    data: data
  })
}

// 删除用户优惠券信息
export function delCoupon(data) {
  return request({
    url: '/user/user-coupon/delete',
    method: 'post',
    data: data
  })
}
